<template>
  <div>
    <CardedForm
      ref="streets_form_ref"
      id="streets_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <TextField
        v-model="form.name"
        :validation_rules="form_validations.name"
        label="Name Of Street"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>

      <SelectField
        v-model="form.district_id"
        :options="districts"
        :small_chips="false"
        :validation_rules="form_validations.district_id"
        label="District"
        icon="mdi-pen-plus"
        :disabled="is_loading"
        :is_loading_info="is_loading_info"
        :item_text="'name'"
        :item_value="'id'"
      ></SelectField>

      <SelectField
        v-model="form.city_id"
        :options="cities"
        :small_chips="false"
        :validation_rules="form_validations.city_id"
        label="City"
        icon="mdi-pen-plus"
        :disabled="is_loading"
        :is_loading_info="is_loading_cities_info"
        :item_text="'name'"
        :item_value="'id'"
      ></SelectField>

      <SelectField
        v-model="form.ward_id"
        :options="wards"
        :small_chips="false"
        :validation_rules="form_validations.ward_id"
        label="Ward"
        icon="mdi-pen-plus"
        :disabled="is_loading"
        :is_loading_info="is_loading_wards_info"
        :item_text="'name'"
        :item_value="'id'"
      ></SelectField>
    </CardedForm>
  </div>
</template>

<script>
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import SelectField from "../../../components/SelectField";
import Utils from "../../../lib/Utils";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminStreetsAdd",
  components: {
    CardedForm,
    TextField,
    SelectField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      errors: [],
      message: "",
      form: {
        name: "",
        district_id: null,
        city_id: null,
        ward_id: null,
      },
      form_validations: {
        name: [
          Utils.validate.is_required("Ward name is required"),
          Utils.validate.min_max_length(
            2,
            30,
            "Ward name should be between 2 and 30 characters "
          ),
        ],
        district_id: [Utils.validate.is_required("Please select a district")],
        city_id: [Utils.validate.is_required("Please select a city")],
        ward_id: [Utils.validate.is_required("Please select a ward")],
      },
      districts: [],
      is_loading_info: false,
      is_loading_cities_info: false,
      is_loading_wards_info: false,
      edit_street_id: 0,
    };
  },
  methods: {
    on_auto_fill() {
      this.init_form();
      var rnd = Math.ceil(Math.random() * 999);
      this.form.name = "street_name_" + rnd;
      this.form.district_id = 1;
      this.form.city_id = null;
      this.form.ward_id = null;
    },
    init_form() {
      this.form.name = "";
      this.form.district_id = null;
      this.form.city_id = null;
      this.form.ward_id = null;
      this.errors = [];
      this.message = "";
      this.$refs.streets_form_ref.on_clear_form();
    },
    submit() {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      if (this.is_editing == true) {
        ServerClient.Locations.update_street(
          {
            id: this.edit_street_id,
            ...this.form,
          },
          (res) => {
            console.log("edit street res", res);
            this.$emit("on-hide-loader");
            this.message =
              "<b>Edit Was Successfull</b> <br/>  Street has been edited";
            this.$refs.streets_form_ref.show_message_dialog();
          },
          (errors) => {
            console.log("edit street errors", errors);
            this.errors = errors;
            this.$refs.streets_form_ref.show_error_dialog();
            this.$emit("on-hide-loader");
          }
        );
      } else {
        ServerClient.Locations.post_street(
          this.form,
          (res) => {
            console.log("add street res", res);
            this.$emit("on-hide-loader");
            this.message =
              "<b>Operation Was Successfull</b> <br/>  Street was added";
            this.$refs.streets_form_ref.show_message_dialog();
          },
          (errors) => {
            console.log("add streets errors", errors);
            this.errors = errors;
            this.$refs.streets_form_ref.show_error_dialog();
            this.$emit("on-hide-loader");
          }
        );
      }
    },
    on_hide_message() {
      if (this.is_editing == true) {
        this.$emit("on-success-edit");
      } else {
        this.init_form();
      }
    },
    fill_edit_street(street) {
      console.log("street to be edited ", street);
      this.edit_street_id = street.id;
      this.form.name = street.name;
      this.form.district_id = parseInt(street.district_id);
      this.form.city_id = parseInt(street.city_id);
      this.form.ward_id = parseInt(street.ward_id);
      this.errors = [];
      this.message = "";
    },
    load_districts() {
      this.is_loading_info = true;
      ServerClient.Locations.get_districts(
        {
          is_drop_down_with_cities_wards: true,
        },
        (res) => {
          this.districts = res;
          this.is_loading_info = false;
        },
        (errors) => {
          this.is_loading_info = false;
          console.log("Errors loading districts on add street");
        }
      );
    },
  },
  computed: {
    cities() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        if (parseInt(district.id) == parseInt(this.form.district_id)) {
          temp = district.cities;
        }
      }
      return temp;
    },
    wards() {
      var temp = [];
      for (var index = 0; index < this.districts.length; index++) {
        var district = this.districts[index];
        if (parseInt(district.id) == parseInt(this.form.district_id)) {
          temp = district.wards;
        }
      }
      return temp;
    },
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Add A Street",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "New Street",
          disabled: true,
          href: "/admin/locations/street/add",
        },
      ],
    });
    this.init_form();
    this.load_districts();
  },
};
</script>